module.exports = __webpack_public_path__ + "static/media/Sparta.e56bcaec.jpg";